export const formatDimensionValue = (showId, externalId, name) => {
    if (!showId || !externalId) {
        return name;
    }
    return `${externalId}--${name}`;
};
export const formatAllocation = (showIntacctId, template) => {
    const base = showIntacctId ? `${template.externalId}--` : '';
    return template.description
        ? `${base}${template.description}`
        : template.externalId;
};
//# sourceMappingURL=format-dimension-value.js.map